import { render, staticRenderFns } from "./scorecard-make-order.vue?vue&type=template&id=35d8fb50&scoped=true"
import script from "./scorecard-make-order.vue?vue&type=script&lang=js"
export * from "./scorecard-make-order.vue?vue&type=script&lang=js"
import style0 from "./scorecard-make-order.vue?vue&type=style&index=0&id=35d8fb50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d8fb50",
  null
  
)

export default component.exports